// Analytics constants — ported from PMHero/src/client/common/constants.ts
export const WIDGET_TYPES = [
    { value: 'bar', label: 'Bar Chart', icon: 'bi-bar-chart' },
    { value: 'line', label: 'Line Chart', icon: 'bi-graph-up' },
    { value: 'pie', label: 'Pie Chart', icon: 'bi-pie-chart' },
    { value: 'doughnut', label: 'Doughnut Chart', icon: 'bi-circle' },
    { value: 'area', label: 'Area Chart', icon: 'bi-graph-up-arrow' },
    { value: 'metric', label: 'Metric', icon: 'bi-123' },
    { value: 'table', label: 'Table', icon: 'bi-table' },
];
export const CHART_TYPES = new Set(['bar', 'line', 'pie', 'doughnut', 'area']);
export const AGGREGATIONS = [
    { value: '', label: 'None' },
    { value: 'count', label: 'Count' },
    { value: 'sum', label: 'Sum' },
    { value: 'avg', label: 'Average' },
    { value: 'min', label: 'Min' },
    { value: 'max', label: 'Max' },
];
/** Map a column data type to a Bootstrap icon class */
export const fieldKindIcon = (kind) => {
    const k = kind.toLowerCase();
    if (k === 'number' || k === 'decimal' || k === 'integer'
        || k === 'numeric' || k === 'bigint' || k === 'smallint'
        || k === 'double precision' || k === 'real')
        return 'bi-hash';
    if (k === 'date' || k === 'timestamp without time zone'
        || k === 'timestamp with time zone')
        return 'bi-calendar';
    if (k === 'boolean')
        return 'bi-check-square';
    if (k === 'time' || k === 'time without time zone'
        || k === 'time with time zone')
        return 'bi-clock';
    if (k === 'uuid')
        return 'bi-key';
    if (k === 'jsonb' || k === 'json')
        return 'bi-braces';
    if (k === 'ARRAY' || k.endsWith('[]'))
        return 'bi-list';
    return 'bi-fonts';
};
